export const queries = {
   config:"config",
   activities:"activities",
   snapshot:"snapshot"
}